"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNoteForm = void 0;
var react_1 = __importStar(require("react"));
var helpers_1 = require("../../helpers");
var SET_FIELD_VALUE = 'SET_FIELD_VALUE';
var SET_ERRORS = 'SET_ERRORS';
var RESET = 'RESET';
function reducer(state, action) {
    var _a;
    switch (action.type) {
        case SET_FIELD_VALUE:
            return __assign(__assign({}, state), (_a = {}, _a[action.name] = action.value, _a));
        case SET_ERRORS:
            return __assign(__assign({}, state), { errors: action.errors });
        case RESET:
            return __assign({}, action.state);
        default:
            throw new Error();
    }
}
var _a = __read(helpers_1.createContext(), 2), hook = _a[0], Provider = _a[1];
var NoteFormProvider = function (_a) {
    var children = _a.children, noteProp = _a.note;
    var note = noteProp || helpers_1.createNoteDocument();
    var getNoteValues = react_1.useCallback(function (note) {
        return {
            content: helpers_1.getJSONValue(note.content),
            category: note.category,
            subcategories: note.subcategories,
            cards: [],
        };
    }, []);
    var _b = __read(react_1.useReducer(reducer, __assign(__assign({}, getNoteValues(note)), { errors: {} })), 2), state = _b[0], dispatch = _b[1];
    var onFieldChange = react_1.useCallback(function (event) {
        var name = event.target.getAttribute('name');
        var value = event.target
            .value;
        if (name) {
            dispatch({ name: name, type: SET_FIELD_VALUE, value: value });
        }
    }, []);
    var setValue = react_1.useCallback(function (name, value) {
        if (name) {
            dispatch({ name: name, type: SET_FIELD_VALUE, value: value });
        }
    }, []);
    var setErrors = react_1.useCallback(function (errors) {
        dispatch({ type: SET_ERRORS, errors: errors });
    }, []);
    var reset = react_1.useCallback(function (note) {
        if (note === void 0) { note = helpers_1.createNoteDocument(); }
        dispatch({
            state: __assign(__assign({}, getNoteValues(note)), { errors: {} }),
            type: RESET,
        });
    }, [getNoteValues]);
    var noteWithId = note;
    return (react_1.default.createElement(Provider, { value: __assign(__assign({}, state), { onFieldChange: onFieldChange,
            reset: reset,
            setErrors: setErrors,
            setValue: setValue, originalNote: noteProp, id: noteWithId.id || null }) }, children));
};
exports.useNoteForm = hook;
exports.default = NoteFormProvider;
//# sourceMappingURL=NoteFormProvider.js.map